<form [formGroup]="endMarketsCustomersForm">
  <mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'asset-end-markets-customers'">
    @let isEditable = endMarketsCustomersIsEditable$ | async;
    @let hasWebsiteUrl = hasWebsiteUrl$ | async;
    <mat-card-header class="detail-card-header">
      <mat-card-title data-test="title">End Markets / Customers</mat-card-title>
    </mat-card-header>
    @if (selectedAsset$ | async; as selectedAsset) {
      @if (endMarketsCustomers$ | async; as endMarketsCustomers) {
        <mat-card-subtitle>
          @if ((gptEndMarkets$ | async)?.status === 'ERROR') {
            <valumize-info-panel [appearance]="'ERROR'" [message]="gptErrorMessage"></valumize-info-panel>
          }
          @if (selectedAsset.status === 'ERROR') {
            <valumize-info-panel [appearance]="'ERROR'" [message]="selectedAsset.errorMessage"></valumize-info-panel>
          }
          @if (selectedAsset.status === 'SAVED') {
            <valumize-info-panel [appearance]="'SAVED'" [message]="'Successfully saved'"></valumize-info-panel>
          }
          @if (selectedAsset.status === 'LOADING') {
            <mat-progress-spinner></mat-progress-spinner>
          }
        </mat-card-subtitle>
        <mat-card-content class="detail-card-content">
          <div class="end-markets-customers-form">
            <div class="description-section">
              @if (!isEditable && endMarketsCustomers.text) {
                <div class="line-breaks">
                  {{endMarketsCustomers.text}}
                </div>
              } @else {
                @if (!isEditable) {
                  <div class="no-text" style="color: grey">
                    Please add content for End Markets / Customers!
                  </div>
                }
              }
              @if (isEditable) {
                <div class="description-container">
                  <mat-form-field class="description">
                    <textarea class="line-breaks"
                      style="height: 250px"
                      formControlName="text"
                      data-test="text"
                    matInput></textarea>
                  </mat-form-field>
                  @if (gptEndMarkets$ | async; as gptEndMarkets) {
                    @if (isGptEditMode && gptEndMarkets.status !=='LOADING') {
                      <div class="gpt-actions">
                        <button mat-stroked-button color="primary" (click)="copyGptText(gptEndMarkets.data)">Replace</button>
                        <button mat-stroked-button color="primary" (click)="addGptText(gptEndMarkets.data)">Append</button>
                      </div>
                    }
                  }
                  @if (isGptEditMode && (gptEndMarkets$ | async)?.status !== 'LOADING') {
                    <mat-form-field class="description">
                      <textarea class="line-breaks"
                        [value]="(gptEndMarkets$ | async)?.data?.text || ''"
                        matInput
                      readonly></textarea>
                    </mat-form-field>
                  }
                </div>
              }
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions class="detail-card-actions">
          @if ((gptEndMarkets$ | async)?.status === 'LOADING') {
            <mat-spinner diameter="24"></mat-spinner>
          }
          @if (isEditable) {
            <span [matTooltip]="!hasWebsiteUrl ? 'Please fill in the website first' : ''">
              <button mat-icon-button
                (click)="isGptEditMode ? gptCancel() : gptEditMode()"
                [disabled]="!hasWebsiteUrl"
                class="image-button"
                aria-label="Generate Description">
                <img src="assets/logo.svg" alt="Valumize AI" />
              </button>
            </span>
          }
          <div class="last-modified" data-test="modification-date">Last modified: {{endMarketsCustomers.modDate | timestamp}}</div>
          @if (!isEditable) {
            <button mat-icon-button color="primary"
              data-test="edit-button"
              (click)="editMode()"
              [disabled]="(isEditDisabled$ | async)!">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (isEditable) {
            <button mat-icon-button color="primary" data-test="save-button" (click)="save(); gptCancel()">
              <mat-icon>save</mat-icon>
            </button>
          }
          @if (isEditable) {
            <button mat-icon-button color="primary" data-test="cancel-button" (click)="cancel(); gptCancel()">
              <mat-icon>cancel</mat-icon>
            </button>
          }
          <valumize-card-comments-button [commentSlug]="'asset-end-markets-customers'"></valumize-card-comments-button>
        </mat-card-actions>
      }
    }
  </mat-card>
</form>
